import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS, REPORT_STATUS, TIME_OUT_STATUS, STATUS_START_DELAY } from "@constants"
import { useCallback, useEffect } from "react"
import { batchIdStatusList, batchTableCellData } from "Pages/Batch/Page/@signals"

export default function useManageBatchStatus() {

	const getStatus = useCallback(() => {
		let isMounted = true

		const fetchStatus = () => {
			if (document.hidden) {
				// a background tab keeps its timer but sends nothing; it catches up when shown again
				setTimeout(() => {
					if (isMounted) fetchStatus()
				}, TIME_OUT_STATUS)
				return
			}
			if (!!batchIdStatusList.value.length) {
				postSubmit(`${BACKEND_APIS.BATCH}/status-multiple`, { executions: batchIdStatusList.value?.map(id => id) })
					.then(res => {
						if (!isMounted) return

						const filteredIds = Object.values(res)
							.filter(item => item?.status === REPORT_STATUS.RUNNING)
							.map(({ idBatch }) => idBatch)

						if (filteredIds.length !== batchIdStatusList.value.length) {
							batchIdStatusList.value = filteredIds
						}

						if (Object.keys(res).some(key => !res[key].ExecutionGlobalStatusComplete)) {
							setTimeout(() => {
								if (isMounted) fetchStatus()
							}, TIME_OUT_STATUS)
						}

						batchTableCellData.value = { ...batchTableCellData.value, ...res }
					})
			}
		}

		fetchStatus()

		return () => {
			isMounted = false
		}

	}, [batchIdStatusList.value.length])

	useEffect(() => {
		// getStatus is recreated for every row that registers on mount: without the delay each one
		// restarted the poll and fired a POST, N of them for N running rows
		let stop
		const timer = setTimeout(() => { stop = getStatus() }, STATUS_START_DELAY)
		return () => {
			clearTimeout(timer)
			if (stop) stop()
		}
	}, [getStatus])
}